export default __webpack_public_path__ + "static/media/White0005.83bf311e.png";